import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalSection = ({ title, children, testId }) => (
  <section data-testid={testId}>
    <h2 className="font-serif text-xl font-medium text-ink-soft sm:text-2xl">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-[#4A433F]">{children}</div>
  </section>
);

export const PageShell = ({ eyebrow, title, children }) => (
  <div className="min-h-screen bg-sand">
    <header className="sticky top-0 z-40 border-b border-[rgba(26,24,23,0.08)] bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex h-20 max-w-4xl items-center justify-between px-4 sm:px-8">
        <Link to="/" data-testid="legal-logo" className="flex items-baseline gap-2">
          <span className="font-serif text-2xl tracking-tight text-ink">841</span>
          <span className="text-[10px] uppercase tracking-[0.3em] text-gold-dark">wellness</span>
        </Link>
        <Link
          to="/"
          data-testid="legal-back-home"
          className="flex items-center gap-2 text-sm text-[#5C5450] transition-colors duration-300 hover:text-ink"
        >
          <ArrowLeft size={16} /> Back to home
        </Link>
      </div>
    </header>
    <main className="mx-auto max-w-4xl px-4 py-16 sm:px-8 sm:py-24">
      <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-gold-dark">
        {eyebrow}
      </p>
      <h1 className="mb-12 font-serif text-4xl tracking-tight text-ink sm:text-5xl">{title}</h1>
      <div className="space-y-10">{children}</div>
    </main>
    <footer className="border-t border-[rgba(26,24,23,0.08)] py-8 text-center text-xs text-[#8A8079]">
      © 2026 841 wellness · <span className="font-serif italic">strength • balance • self</span>
    </footer>
  </div>
);
